import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    error: null,
    reportData: {},
    reportDetail: [],
    reportListData: {
        reportList: [],
        pagination: {}
    }

};

const report = createSlice({
    name: 'report',
    initialState,
    reducers: {
        reportDataLoad: (state) => {
            state.loading = true
        },
        reportDataSuccess: (state, action) => {
            state.loading = false
            state.reportData = action.payload
        },
        reportDataFail: (state) => {
            state.loading = false
        },
        reportListload: (state) => {
            state.loading = true
        },
        reportListSuccess: (state, action) => {
            state.loading = false
            state.reportListData = action.payload
        },
        reportListFail: (state) => {
            state.loading = false;
        },

        reportDetailLoad: (state) => {
            state.loading = true;
        },

        reportDetailSuccess: (state, action) => {
            state.loading = false;
            state.reportDetail = action.payload;
        },

        reportDetailFail: (state, action) => {
            state.loading = false
        },

        removeReportLoad: () => { },
        removeReportSucees: () => { },
        removeReportFail: () => { }



    }
});

export const {
    reportDataLoad,
    reportDataSuccess,
    reportDataFail,
    reportListload,
    reportListSuccess,
    reportListFail,
    reportDetailLoad,
    reportDetailSuccess,
    reportDetailFail,
    removeReportFail,
    removeReportSucees,
    removeReportLoad
} = report.actions;

export default report.reducer;
